module.exports = "<div class=\"bpg-image-container\" *ngIf=\"displayLogo\">\n    <a href=\"{{bpgImageLink}}\" target=\"_blank\">\n        <img [src]=\"bpgImagePath\" data-slnm-ihg=\"bestPriceGuaranteeLogo\" >\n    </a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/bpg-image/bpg-image.component.html
// module id = ./src/main/webapp/stay-mgmt/app/components/bpg-image/bpg-image.component.html
// module chunks = 0